import React from "react";
import RegisterPage from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const STATUS = {
  Completed: { bg: "#DCFCE7", color: "#166534" },
  Planned: { bg: "#DBEAFE", color: "#1E40AF" },
  "In Progress": { bg: "#FEF3C7", color: "#854D0E" },
  Overdue: { bg: "#FEE2E2", color: "#7F1D1D" },
  Cancelled: { bg: "#F1F5F9", color: "#334155" },
};

export default function PermitToWork() {
  const { data, siteNames } = useHSE();
  const rows = data.emergencyDrills || [];

  const statuses = ["Completed", "Planned", "In Progress", "Overdue", "Cancelled"];
  const stats = statuses.map((s) => ({
    s,
    n: rows.filter((p) => p.status === s).length,
  }));

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      {stats.map((x) => (
        <div key={x.s} className="command-card p-3.5">
          <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{x.s}</div>
          <div className="font-heading font-bold text-2xl tabular text-[#0E2336] mt-0.5">{x.n}</div>
        </div>
      ))}
    </div>
  );

  return (
    <RegisterPage
      title="Emergency Drills"
      subtitle="Fire drill, abandon ship, kick drill, mustering, medical emergency and emergency response tracking"
      storeKey="emergencyDrills"
      idPrefix="DRILL"
      topPanels={Top}
      columns={[
        { key: "id", label: "Drill ID" },
        { key: "date", label: "Date" },
        { key: "site", label: "Site" },
        { key: "drillType", label: "Drill Type" },
        { key: "type", label: "Category" },
        { key: "target", label: "Target" },
        { key: "realization", label: "Realization" },
        { key: "participants", label: "Participants" },
        { key: "status", label: "Status" },
        { key: "remarks", label: "Remarks" },
      ]}
      badgeMap={{ status: STATUS }}
      formFields={[
        { key: "id", label: "Drill ID" },
        { key: "date", label: "Date", type: "date" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "drillType", label: "Drill Type", type: "select", options: ["Fire Drill", "Abandon Drill", "Fire and Abandon Ship Drill", "Kick Drill", "Medical Emergency", "General Alarm / Mustering", "Oil Spill Drill", "Man Overboard Drill", "Security Drill"] },
        { key: "type", label: "Category" },
        { key: "target", label: "Target" },
        { key: "realization", label: "Realization" },
        { key: "participants", label: "Participants" },
        { key: "status", label: "Status", type: "select", options: ["Completed", "Planned", "In Progress", "Overdue", "Cancelled"] },
        { key: "remarks", label: "Remarks" },
      ]}
    />
  );
}
